import * as React from "react";

import MerchantDetailTopBar from "./Ops.Merchants.MerchantDetailTopBar";
import CardCashbackStrategyContainer from "../../Merchants/CashbackStrategies/CardCashbackStrategyContainer";
import gql from "graphql-tag";
import { graphql, compose } from "react-apollo";

type Props = {
  query: () => void;
  data: any;
  editCard: (variables: any) => Promise<void>;
};

type State = {
  data: any;
  urls: any;
};

class CashbackStrategy extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);

    this.state = {
      data: null,
      urls: {}
    };

    this.loadData = this.loadData.bind(this);
  }

  componentDidMount() {
    this.loadData();
  }

  loadData() {
    this.props.data.fetchMore({
      updateQuery: (previousResult, { fetchMoreResult }) => {
        this.setState({
          data: fetchMoreResult.merchant.cards,
          urls: fetchMoreResult.cashback_strategy_urls
        });
      }
    });
  }

  render() {
    const cards = this.state.data ? this.state.data : [];
    return (
      <React.Fragment>
        <MerchantDetailTopBar />
        <section
          className="padded"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            overflowY: "auto",
            overflowX: "hidden"
          }}
        >
          <div>
            {cards.map((card, ckey) => (
              <CardCashbackStrategyContainer
                key={ckey}
                card={card}
                urls={this.state.urls}
                editCard={this.props.editCard}
                fetchCardCashbackStrategies={() => this.loadData()}
              />
            ))}
          </div>
        </section>
      </React.Fragment>
    );
  }
}

const queryCardCashbackStrategies = graphql(
  gql`
    query Merchant($id: ID!) {
      cashback_strategy_urls {
        snapmin_create_fixed_url
        snapmin_create_percentage_url
      }
      merchant(id: $id) {
        name
        email
        cards {
          id
          created_at
          store_name
          qr_codes {
            code
          }
          cashback_strategy {
            id
            type
            description
            value
            updated_at
            maximum_cashback_per_payment
            maximum_total_payout
            minimum_payment_amount
            user_limit_amount
            user_limit_type
            strategy_limit_amount
          }
        }
      }
    }
  `,
  {
    options(props: any) {
      return {
        variables: {
          id: props.match.params.id
        }
      };
    }
  }
);

const editCardMutation = graphql(
  gql`
    mutation editCard($id: ID!, $cashback_strategy_id: ID!) {
      update_card_cashback_strategy(
        id: $id
        cashback_strategy_id: $cashback_strategy_id
      ) {
        id
        cashback_strategy {
          id
        }
      }
    }
  `,
  { name: "editCard" }
);

export default compose<any>(
  queryCardCashbackStrategies,
  editCardMutation
)(CashbackStrategy);
